import React from 'react';
import { Button } from '@els/els-react--button';
import SelectAllItemsControls from '@Containers/ResultToolbar/SelectedItemsControls/SelectAllItemsControls';
import SortBy from '@Containers/ResultToolbar/SortBy';

function ResultToolbarPrimary(props) {
  const {
    disableLimit,
    limitTo,
    isExportEnabled,
    openExportDialog,
    chemquoteEnabled,
    isSubstancesContext,
    supportsReactions,
    showAllPreparations,
  } = props;
  return (
    <div className="o-els-flex-layout o-els-flex-layout--space-between">
      <div className="o-els-flex-layout__item o-els-flex-layout o-els-flex-layout--middle o-els-flex-layout--wrap@mobile">
        <SelectAllItemsControls {...props} />
        <Button
          id="limit"
          type="link"
          onClick={() => {
            limitTo();
          }}
          disabled={disableLimit}
          className="u-els-margin-right"
          aria-label="Limit To"
          data-e2e="limit-button">
          Limit To
        </Button>
        <Button
          type="link"
          onClick={() => {
            limitTo({ exclude: true });
          }}
          disabled={disableLimit}
          className="u-els-margin-right"
          aria-label="Exclude"
          data-e2e="exclude-button">
          Exclude
        </Button>
        <Button
          id="export-button"
          type="link"
          onClick={() => {
            openExportDialog();
          }}
          disabled={!isExportEnabled}
          className="u-els-margin-right"
          data-e2e="export-button">
          Export
        </Button>
        {isSubstancesContext && chemquoteEnabled && (
          <Button
            id="exportChemquote"
            type="link"
            onClick={() => {
              openExportDialog('ChemQuote');
            }}
            disabled={!isExportEnabled}
            className="u-els-margin-right"
            data-e2e="export-chemquote-button">
            Novartis ChemQuote
          </Button>
        )}
        {isSubstancesContext && supportsReactions && (
          <Button
            id="showAllPreparations"
            title="Show all Preparations with Substance as a Product"
            type="link"
            onClick={() => {
              showAllPreparations();
            }}
            className="u-els-margin-right"
            data-e2e="preparations-button">
            Preparations
          </Button>
        )}
      </div>
      <div className="o-els-flex-layout__item">
        <SortBy {...props} />
      </div>
    </div>
  );
}

export default ResultToolbarPrimary;
